<template>
  <div class="w-full min-h-screen bg-white shadow-lg overflow-y-auto">
    <!-- Capa -->
    <div class="w-full h-64 bg-gray-100 relative group">
      <img
        v-if="coverPhoto"
        :src="coverPhoto"
        alt="Capa da empresa"
        class="w-full h-full object-contain lg:object-cover bg-gray-100"
        style="object-position: center"
      />

      <p
        v-else
        class="absolute bottom-1 w-full text-[10px] text-gray-500 italic text-center bg-white/70"
      >
        3.750 x 720
      </p>

      <input
        type="file"
        @change="uploadCover"
        class="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
      />

      <div class="absolute top-2 right-2" v-if="coverPhoto">
        <button
          @click.stop="removeCover"
          class="bg-white text-red-500 hover:bg-red-500 hover:text-white text-[15px] rounded-full px-2 py-1 shadow leading-none group-hover:block"
        >
          🗑️
        </button>
      </div>
    </div>

    <!-- Perfil e informações -->

    <div class="relative p-6">
      <div
        class="absolute top-[-60px] left-6 w-32 h-32 rounded-full border-4 border-white bg-gray-200 overflow-hidden group"
      >
        <img
          v-if="profilePhoto"
          :src="profilePhoto"
          alt="Foto da empresa"
          class="w-full h-full object-cover"
        />

        <input
          type="file"
          @change="uploadImage"
          class="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
        />

        <div class="absolute top-0 right-2" v-if="profilePhoto">
          <button
            @click.stop="removePhoto"
            class="bg-white text-red-500 hover:bg-red-500 hover:text-white text-[15px] rounded-full px-1 py-0.5 shadow leading-none group-hover:block"
          >
            🗑️
          </button>
        </div>

        <p
          v-else
          class="absolute bottom-1 w-full text-[10px] text-gray-500 italic text-center bg-white/70"
        >
          Formato PNG
        </p>
      </div>

      <!-- Dados da empresa -->
      <div class="ml-40 max-w-xl p-6">
        <h1 v-if="company" class="text-4xl font-extrabold text-gray-800">
          {{ company.NomeEmpresa }}
        </h1>
        <h2 class="text-xl font-semibold text-gray-700">
          Bem-vindo, <span class="text-blue-600">{{ UserName }}</span>
        </h2>

        <div v-if="company" class="space-y-1 text-gray-700">
          <p><span class="font-semibold">CNPJ:</span> {{ company.CNPJ }}</p>
          <p><span class="font-semibold">Cidade:</span> {{ company.Cidade }}</p>
          <p>
            <span class="font-semibold">Segmento:</span> {{ company.Segmento }}
          </p>
          <p>
            <span class="font-semibold">Site:</span>
            <a
              :href="company.Site"
              target="_blank"
              class="text-blue-600 hover:underline"
            >
              {{ company.Site }}
            </a>
          </p>
        </div>
      </div>
    </div>
    <h1 style="color: #2c3e50" class="mb-16 ml-8 font-bold text-5xl">
      Dashboard de Maturidade em Segurança da Informação
    </h1>

    <Card1 />

    <!-- Botão de logout -->
    <div class="flex justify-end mr-4">
      <button
        @click="logout"
        class="px-6 py-2 border border-gray-300 rounded-md text-red-600 font-semibold hover:bg-gray-100 transition"
      >
        Sair
      </button>
    </div>

    <p v-if="errorMessage" class="text-red-500 text-sm mt-2">
      {{ errorMessage }}
    </p>

    <!-- Cards -->
    <div v-if="!showQuestionComponent">
      <div class="container mx-auto px-4 py-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <!-- Card botão -->
          <div
            class="w-full h-[100px] bg-gradient-to-br from-gray-200 to-gray-300 rounded-xl relative shadow-md border border-gray-400 overflow-hidden group"
          >
            <div
              class="absolute inset-0 bg-gradient-to-r from-lime-400/10 via-orange-400/10 to-lime-300/10 blur-md opacity-40 group-hover:opacity-70 transition duration-500 pointer-events-none"
            ></div>
            <div
              class="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-blue-400 transition duration-300 pointer-events-none"
            ></div>
            <button
              @click="showQuestionComponent = true"
              class="absolute inset-0 w-full flex items-center justify-center text-base font-medium text-gray-700 group-hover:text-black transition duration-300"
            >
              📄 Abrir Perguntas
            </button>
          </div>

          <!-- Container dos dois gráficos lado a lado -->

          <div class="col-span-2 flex gap-2 justify-center">
            <div class="h-[300px] w-[400px] bg-gray-100 rounded-2xl p-4 flex">
              <PieCategorizationCharts
                :key="pieChartKey"
                :idEnterprise="company._id"
                class="w-full h-full m-2.5"
              />
            </div>

            <div class="h-[300px] w-[600px] bg-gray-100 rounded-2xl p-4 flex">
              <BarChartsCategorization
                :key="barChartKey"
                :idEnterprise="company._id"
                class="w-full h-full m-2.5"
              />
            </div>
          </div>

          <!-- Tabela -->
          <div
            class="col-span-3 w-full bg-gray-100 rounded-2xl p-4 flex flex-col"
          >
            <Categorization_table
              :key="tableKey"
              :idEnterprise="company._id"
              :enterpriseName="company.NomeEmpresa"
            />
          </div>
        </div>
      </div>

      <!-- Modal -->
    </div>
    <div
      v-if="showQuestionComponent"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
    >
      <div
        class="relative w-full h-full bg-black bg-opacity-50 p-4 overflow-auto"
      >
        <button
          @click="showQuestionComponent = false"
          class="absolute top-3 right-4 text-gray-300 hover:text-white text-2xl"
        >
          ✖
        </button>
        <QuestionComponent
          :enterpriseId="company._id"
          :enterprise-name="company.NomeEmpresa"
          @closed="handleModalClose"
        />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionComponent from '@/components/perfil/QuestionEmployees.vue'
import {
  deleteFilesByName,
  getFilesBase64ByFileName,
  sendFile,
} from '@/services/documents/api.files.js'
import Card1 from '@/views/cards/Card1.vue'
import Categorization_table from '@/views/page/categorization_table/Categorization_table.vue'
import BarChartsCategorization from '@/views/page/charts/BarChartsCategorization.vue'
import PieCategorizationCharts from '@/views/page/charts/PieChartsCategorization.vue'
export default {
  props: ['company'],
  components: {
    BarChartsCategorization,
    PieCategorizationCharts,
    Categorization_table,
    QuestionComponent,
    Card1,
  },
  data() {
    return {
      profilePhoto: '',
      coverPhoto: '',
      errorMessage: '',
      showQuestionComponent: false,
      UserName: localStorage.getItem('Name') || '',
      pieChartKey: 0,
      barChartKey: 0,
      tableKey: 0,
    }
  },
  watch: {
    company: {
      handler() {
        this.fetchProfilePhoto()
        this.fetchCoverPhoto()
      },
      immediate: true,
    },
  },
  methods: {
    async handleModalClose() {
      this.showQuestionComponent = false
    },

    async removePhoto() {
      try {
        const fileName = `${this.company.NomeEmpresa}.png`
        const response = await deleteFilesByName(fileName, 'file')
        this.profilePhoto = ''
        this.errorMessage = ''
      } catch (error) {
        this.errorMessage = 'Erro ao deletar a imagem de perfil.'
      }
    },

    async removeCover() {
      try {
        const fileName = `${this.company.NomeEmpresa}.png`
        const response = await deleteFilesByName(fileName, 'cover')
        this.coverPhoto = ''
        this.errorMessage = ''
      } catch (error) {
        this.errorMessage = 'Erro ao deletar a capa.'
      }
    },

    async uploadImage(event) {
      const file = event.target.files[0]
      if (!file || !this.company?.NomeEmpresa) return

      const ext = file.name.split('.').pop().toLowerCase()
      if (ext !== 'png') {
        this.errorMessage = 'Erro: Apenas imagens PNG são suportadas.'
        return
      }

      const fileName = `${this.company.NomeEmpresa}.png`

      try {
        await sendFile(file, fileName)
        const base64Data = await getFilesBase64ByFileName(fileName)
        this.profilePhoto = base64Data?.base64 || ''
        this.errorMessage = ''
      } catch {
        this.errorMessage = 'Erro no upload da imagem de perfil.'
      }
    },

    async uploadCover(event) {
      const file = event.target.files[0]
      if (!file || !this.company?.NomeEmpresa) return

      const ext = file.name.split('.').pop().toLowerCase()
      if (ext !== 'png') {
        this.errorMessage = 'Erro: Apenas imagens PNG são suportadas.'
        return
      }

      const fileName = `${this.company.NomeEmpresa}.png`

      try {
        await sendFile(file, fileName, 'cover')
        const base64Data = await getFilesBase64ByFileName(fileName, 'cover')
        this.coverPhoto = base64Data?.base64 || ''
        this.errorMessage = ''
      } catch {
        this.errorMessage = 'Erro no upload da capa.'
      }
    },

    async fetchProfilePhoto() {
      if (!this.company?.NomeEmpresa) return
      try {
        const fileName = `${this.company.NomeEmpresa}.png`
        const base64Data = await getFilesBase64ByFileName(fileName, 'file')
        this.profilePhoto = base64Data?.base64 || ''
      } catch {}
    },

    async fetchCoverPhoto() {
      if (!this.company?.NomeEmpresa) return
      try {
        const fileName = `${this.company.NomeEmpresa}.png`
        const base64Data = await getFilesBase64ByFileName(fileName, 'cover')
        this.coverPhoto = base64Data?.base64 || ''
      } catch {}
    },

    logout() {
      localStorage.removeItem('Name')
      localStorage.removeItem('accessedControllers')
      localStorage.removeItem('userId')
      localStorage.removeItem('role')
      localStorage.removeItem('enterprise')
      localStorage.removeItem('selectedCompany')
      localStorage.removeItem('Token')
      this.$router.push('/')
    },
  },
}
</script>

<style scoped>
input[type='file'] {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
